//
// change text and styling on toggle
//

var ToggleAccordionButtons = (function () {
    'use strict';

    var accordion = document.querySelectorAll('#financialAccordion');

    function init() {
        var $toggleBtns = $(accordion).find('[data-toggle="button"]');
        var $submitBtn = $('.btn[type="submit"]');
        $submitBtn.attr('disabled', 'disabled');

        //find all accounts
        var buttonAccounts = [];
        $toggleBtns.each(function () {
            buttonAccounts.push($(this).attr('data-acc'));
        });

        //only unique accounts
        var uniqueAccounts = [];
        uniqueAccounts = buttonAccounts.filter(function (v, i, a) {
            return a.indexOf(v) === i;
        });

        var selectedAccounts = [];

        $toggleBtns.on("click", function (e) {
            $(this).parents(".collapse").find('[data-toggle="button"]').not($(this)).removeClass('active').text('Select Option');
            $(this).parents('.card-offer').siblings('.card-offer.highlighted').removeClass('highlighted');

            var account = $(this).data('acc');

            if (!$(this).hasClass('active')) {
                if (selectedAccounts.length == 0) {
                    selectedAccounts.push(account);
                }
                else if (!selectedAccounts.includes(account)) {
                    selectedAccounts.push(account);
                }
                $(this).parents(".card-offer").addClass('highlighted');
                $(this).text("Selected");
            } else {
                selectedAccounts = selectedAccounts.filter(function (item) {
                    return item !== account;
                });
                $(this).parents(".card-offer").removeClass('highlighted');
                $(this).text("Select Option");
            }

            if (selectedAccounts.length == uniqueAccounts.length) {
                $submitBtn.removeAttr('disabled');
            }
            else {
                $submitBtn.attr('disabled', 'disabled');
            }
        });
    }


    if (accordion.length) {
        init();
    }
})();
